import { NeedUserAttention } from '../../model/need-user-attention';

export function isNeedUserAttention(a: any): a is NeedUserAttention {
  return !!a && !!(a as NeedUserAttention).userAttentionNeeded;
}
